import request from '@/utils/request';
// 获取会员列表
export function memberList() {
	return request({
		url: '/management/member/list',
		method: 'get',
	})
}